// Menu mobile: burger mở/đóng drawer, click ra ngoài thì đóng.
window.addEventListener("load", function () {
  const nav = document.querySelector("#navigation");
  if (!nav) return;

  const burger = nav.querySelector(".nav-burger");
  const drawer = nav.querySelector(".nav-drawer");
  if (!burger || !drawer) return;

  const setOpen = (open) => {
    drawer.hidden = !open;
    burger.setAttribute("aria-expanded", String(open));
  };

  burger.addEventListener("click", function (event) {
    event.stopPropagation();
    setOpen(drawer.hidden);
  });

  drawer.addEventListener("click", function () {
    setOpen(false);
  });

  document.addEventListener("click", function (event) {
    if (drawer.hidden || drawer.contains(event.target)) return;
    setOpen(false);
  });
});
